// Copyright (c) 2015, Intelligent IoT Pvt. Ltd. and Contributors
// MIT License. See license.txt

if (cx.require) {
	cx.require("file_uploader.bundle.js");
} else {
	cx.ready(function () {
		cx.require("file_uploader.bundle.js");
	});
}
